import { SELECIONAR_ITINERARIOS } from '../types'

export default function selecionarItinerarios (itinerarios) {
  return {
    type: SELECIONAR_ITINERARIOS,
    payload: itinerarios
  }
}